export default {
    header: 'Find jobs',
    changeFilters: 'Change filters',

    recruitmentModule: {
        body: `Are you a recruitment officer, career professional or just
        interested in hiring student talent?`,
        createJob: 'Click here to create job post',
    },
};
